import { Component, OnInit } from '@angular/core'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { PriceQuoteStatusCreateComponent } from '../../../features/price-quote/price-quote-status-create/price-quote-status-create.component'
import { MatButton } from '@angular/material/button'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { ProposalClientCreateComponent } from '../../../features/proposal/proposal-client-create/proposal-client-create.component'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { convertCurrency } from '../../../shared/utils/utils'
import { ProposalClientEditComponent } from '../../../features/proposal/proposal-client-edit/proposal-client-edit.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import { ModalDownloadProposalComponent } from '../../../features/proposal/modal-download-proposal/modal-download-proposal.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ModalMessageEmailComponent } from '../../../features/proposal/modal-message-email/modal-message-email.component'
import { TableListProposalPageComponent } from '../../../shared/components/table-list-proposal-page/table-list-proposal-page.component'
import { FormSearchProposalClientComponent } from '../../../shared/components/form-search-proposal-client/form-search-proposal-client.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { ModalCancelProposalComponent } from '../../../features/proposal/modal-cancel-proposal/modal-cancel-proposal.component'
import { ModalCreateContractComponent } from '../../../features/proposal/modal-create-contract/modal-create-contract.component'
import { ProposalClientReplicateComponent } from '../../../features/proposal/proposal-client-replicate/proposal-client-replicate.component'

@Component({
  selector: 'proposal-client',
  imports: [
    FormSearchComponent,
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    PriceQuoteStatusCreateComponent,
    MatButton,
    FormClientSearchComponent,
    MatPaginatorModule,
    TableListProposalPageComponent,
    FormSearchProposalClientComponent,
    MatExpansionModule,
  ],
  templateUrl: './proposal-client.component.html',
  styleUrl: './proposal-client.component.scss',
  providers: [ProposalClientService, AuthService],
  standalone: true,
})
export class ProposalClientComponent implements OnInit {
  constructor(
    private proposalClientService: ProposalClientService,
    private snackbar: SnackbarCustomService,

    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  // searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  searchForm: any = { search: false, model: {} }
  inputSearch = ''
  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'tgCode',
      key: 'codigoTg',
      description: 'Codigo tg',
    },
    {
      keyColumn: 'event',
      key: 'nomeEvento',
      description: 'Evento',
    },
    {
      keyColumn: 'period',
      key: 'dataInicio',
      description: 'Período',
    },
    {
      keyColumn: 'client_info',
      key: 'nomecliente',
      description: 'Cliente',
    },
    {
      keyColumn: 'consultant_info',
      key: 'nomeConsultor',
      description: 'Consultor',
    },
    // {
    //   keyColumn: 'dateStart',
    //   key: 'dataInicio',
    //   description: 'Início',
    // },
    // {
    //   keyColumn: 'dateEnd',
    //   key: 'dataFim',
    //   description: 'Fim',
    // },
    // {
    //   keyColumn: 'conslutant',
    //   key: 'nomeConsultor',
    //   description: 'Consultor',
    // },
    {
      keyColumn: 'pax',
      key: 'quantidadePassageiros',
      description: 'Pax',
    },
    {
      keyColumn: 'total',
      key: 'valorTotalFormatado',
      description: 'Valor Total',
    },
    {
      keyColumn: 'status',
      key: 'statusPropostaDescricao',
      description: 'Status',
    },
    {
      keyColumn: 'emission',
      key: 'dataCriacao',
      description: 'Emissão',
    },
    {
      keyColumn: 'action',
      key: {
        edit: false,
        delete: false,
        download: true,
        view: true,
        sendContract: true,
        sendEmail: true,
        replicateItem: true,
      },
      description: 'Ações',
    },
  ]

  spinLoad: any = {
    contract: false,
    email: false,
    download: false,
    edit: false,
    manager: false,
    view: false,
    remove: false,
  }

  screen = 'proposta cliente'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        // edit: this.checkPermission('editar'),
        // delete: this.checkPermission('deletar'),
        delete: true,
        download: true,
        view: true,
        sendContract: true,
        sendEmail: true,
        replicateItem: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    this.page = 1
    this.searchForm = event
    if (event.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.proposalClientService
      .listPagedProposalClient(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.proposalClientService
      .searchPagedProposalClient(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newPriceQuote() {
    const dialogRef = this.dialog.open(ProposalClientCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })

    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  createContract(item: any) {
    const dialogRef = this.dialog.open(ModalCreateContractComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '900px',
      width: '900px',
      data: { item: item },
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  sendEmail(item: any) {
    const dialogRef = this.dialog.open(ModalMessageEmailComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '700px',
      width: '700px',
      data: { item: item },
    })

    dialogRef.afterClosed().subscribe((result) => {
      this.uploadList()
    })
  }

  modalDownload(item: any) {
    const dialogRef = this.dialog.open(ModalDownloadProposalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '400px',
      width: '400px',
      data: { id: item.id, item: item },
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ProposalClientEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  replicateItem(item: any) {
    const dialogRef = this.dialog.open(ProposalClientReplicateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  // downloadItem(item: any) {
  //   this.proposalClientService.downloadProposalClient(item.id).subscribe({
  //     next: (response: any) => {
  //       downloadBase64File(
  //         response.data.fileContent,
  //         response.data.fileName,
  //         response.data.type,
  //       )
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => {},
  //   })
  // }

  deleteItem(item: any) {
    const dialogRef = this.dialog.open(ModalCancelProposalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '900px',
      width: '900px',
      data: { item: item },
    })
    dialogRef.componentInstance.responseDelete.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }
}
